export default "__VITE_ASSET__8165d9f0__"